import React, { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { Box, Button, TextField,  Container,Typography, Alert } from '@mui/material';
import axios from 'axios';
import { useNavigate, Link  } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';

import { Capacitor } from '@capacitor/core';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const GoogleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GoogleAndroidClientId = process.env.REACT_APP_GOOGLE_ANDROID_CLIENT_ID;

const Login = () => {

  const isNative = Capacitor.isNativePlatform();
  //alert("backend:  "+backendUrl);
  console.log("backend url "+backendUrl);
        const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
     const { t } = useTranslation();
      const navigate = useNavigate();

     const { login , logout, logoutSupplier } = useAuth();
    
     
    useEffect(() => {
         logout(); 
      logoutSupplier(); 
    // Call the onLogout function when the component loads
  //  onLogout();
  }, []);
  
  
  useEffect(() => {
    if(isNative){
        GoogleAuth.initialize({
    clientId: '90157228473-u4jnicp04inhe56bc5o43mnu7ci3iepi.apps.googleusercontent.com',
    scopes: ['profile', 'email'],
    grantOfflineAccess: true,
  });
    }

}, []);
    

    const validatePassword = (value) => {
        let error = '';

        // Rule 1: At least 8 characters
        if (value.length < 8) {
            error = 'Password must be at least 8 characters long.';
          setErrorMessage(error);
          return false;
        } 
        
        // Rule 2: Contain at least one number
        else if (!/.*[0-9].*/.test(value)) {
            error = 'Password must contain at least one number.';
          setErrorMessage(error);
          return false;
        }
        
        // Rule 3: Contain at least one lowercase character (a-z)
        else if (!/.*[a-z].*/.test(value)) {
            error = 'Password must contain at least one lowercase letter (a-z).';
          setErrorMessage(error);
          return false;
        }

        return true;
       
    };
    
    
const handleLogin = (e) => {
    e.preventDefault();

  if(!validatePassword(password)){
    return;
  }
   
    setErrorMessage(''); 
      // console.log('Email:', email );
               const newUser = {
              email: email,
              password: password,
                     wouldBePartner: 0
            };
  
  //console.log("log backedurl "+backendUrl);
      
     //  
  //  axios.post(`${backendUrl}/api/auth/login`, { email, password })
       axios.post(`${backendUrl}/api/users/login`, newUser)
        .then((response) => {
          const user = response.data;
             localStorage.setItem('token', user.token);
         //  console.log(user);
      if (user.active)  {
          // Redirect to dashboard if user exists
           //  console.log('Email:', response.data.userId);
            const userId = response.data.userId;
          
          if(user.wouldBePartner==1){
                setErrorMessage('you already registed the email as supplier. Please user supplier login page.');
               user.wouldBePartner=0;
              return;
          }
          if(user.authorized){
              login(user); 
           navigate('/dashboard');
             }else{
                 
                 if(user.provider){
                     console.log("you already registed using the SSO. Please login using SSO");
                     // Catch and handle errors
                     setErrorMessage('you already registed using the SSO. Please login using SSO.');
      
                 }else{
                     console.log("Please enter the correct password");
                     setErrorMessage('Please enter the correct password.');
                 }
             }
                
        } else {
            
            console.log(" u provider "+ user.provider );
               login(user); 
          // If user doesn't exist, navigate to user details and pass email & password
          navigate('/user-details');
        }
        
      
        }).catch(err => {
            console.error('Login failed', err);
           setErrorMessage('An error occurred during login. Please try again.');
        });
};
    
    


    
const handleGoogleLogin = (response) => {
    
// console.log("token:  " + response.credential); 
setErrorMessage(''); 
  
  const token = response.credential || response.idToken || response.authentication?.idToken;
//alert("Token : ", token);
    if (!token) {
      throw new Error("No ID Token found in response");
    }
        
  
  
     const userObject = jwtDecode(token); 
    
        const email = userObject.email;
    
        const name = userObject.name;
        const givenName = userObject.given_name;
       const  familyName = userObject.family_name;
      const emailVerified = userObject.email_verified;
      //  console.log('User Info:', userObject);
    
    
    
    axios.post(`${backendUrl}/api/auth/google`, {
        tokenId: token,
    }).then((response) => {
        
            const user = response.data;
          localStorage.setItem('token', user.token);
        
     // console.log("res user: ", user);
    //    console.log("res user: "+user.userId);
        
      //    console.log("acti: "+ user.active);
        if (user.active) {
          // Redirect to dashboard if user exists
            const userId = user.userId;
            login(user); 
          navigate('/dashboard');
        } else {
             //  console.log('response.data.exists:', response.data.exists);
           const user = {
                  email:email,      // Replace with actual email
                  name:name,                  // Replace with actual name
                  givenName:givenName,                 // Replace with actual given name
                  familyName:familyName,
                  provider: 'GOOGLE',
                emailVerified:emailVerified,
                partnerId: '',
                wouldBePartner: 0
           };
      
          console.log(user);
               login(user); 
          // Redirect to UserDetails form if user doesn't exist
          navigate('/user-details');
        }
        
      
    }).catch(err => {
        console.error(err);
        // Catch and handle errors
      if (err.response && err.response.status === 401) {
        setErrorMessage('Please enter the correct password'); // Set error message
        console.log('Please enter the correct password');
      } else {
        setErrorMessage('An error occurred during login. Please try again.');
      }
    });
};
  
  
    
    const handleAndroidLogin = async () => {
    try {
      const result = await GoogleAuth.signIn();
      // Send result.authentication.idToken to your Spring Boot service
    //  alert("Success: " + JSON.stringify(result));
      handleGoogleLogin(result); 
    } catch (err) {
    //  alert("Login Error: " + JSON.stringify(err));
      console.error("Android Login Error:", err);
    }
  };
  
  // 2. Logic for Web (Standard)
  const handleWebSuccess = (response) => {
    // Send response.credential to your Spring Boot service
    handleGoogleLogin(response);
  };
 

    

return (
    
    
          <div>
      <Header />
   <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '100vh',
        justifyContent: 'center',
        padding: 3,
      }}
    >
      {/* Google Login Section */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 4 }}>
        <Typography variant="h5" gutterBottom>
          
          {t('login_with_google', 'Login with Google')}
        </Typography>
    
           {isNative ? (
        /* Custom Button for Android */
        <button onClick={handleAndroidLogin} >
          Sign in with Google (App)
        </button>
      ) : (
     <GoogleOAuthProvider clientId={GoogleClientId}>
      <div className="App">
        <GoogleLogin onSuccess={handleWebSuccess} onError={() => console.log('Error')} />
      </div>
    </GoogleOAuthProvider>
)}
      </Box>
 {/* Error Message Display */}
        {errorMessage && (
          <Alert severity="error" style={{ marginBottom: '20px' }}>
            {errorMessage}
          </Alert>
        )}

      {/* Divider Text */}
      <Typography variant="h6" sx={{ my: 2 }}>
       
{t('or_login_with_email_password', 'Or Login with Email/Password')}
      </Typography>
  

      {/* Email/Password Login Form */}
      <form onSubmit={handleLogin} style={{ width: '100%', maxWidth: '400px' }}>
        {/* Email Input */}
        <TextField
          fullWidth
          label="Email"
          variant="outlined"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ marginBottom: 2 }}
          required
        />

        {/* Password Input */}
        <TextField
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ marginBottom: 2 }}
          required
        />

        {/* Submit Button */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          sx={{ marginBottom: 4 }}
        >
         
 {t('login_with_email_password', ' Login with Email/Password')}
        </Button>
      </form>
  <Typography>By login/registering, you agree to our
            <Link to="/terms">Terms and Conditions</Link> and  <Link to="/privacypolicy">Privacy Policy</Link>
             </Typography>
 {/* Forgot Password Link */}
        <div style={{ marginTop: '10px', textAlign: 'center' }}>
          <Link to="/forgot-password" style={{ textDecoration: 'none', color: '#3f51b5' }}>
            {t('forgot_password', 'Forgot Password')}?
          </Link>
        </div>


</Container>
  <Footer />
      </div>


);
};

export default Login;
